







































































import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  props: {
    testId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      niveaux: [
        { name: "energie_0", title: "Manque", min: 0, max: 0 },
        { name: "energie_1", title: "Faible", min: 0, max: 0 },
        { name: "energie_2", title: "Idéale", min: 0, max: 0 },
        { name: "energie_3", title: "Elevée", min: 0, max: 0 },
        { name: "energie_4", title: "En excès", min: 0, max: 0 }
      ],
      cerveaux: ['Reptilien', 'Limbique', 'Néocortical'],
      combinaisons: [] as Array<{ cerveau1: string; cerveau2: string; niveau: string; energie: string; texte: string; image?: string }>
    };
  },
  methods: {
    generateCombinaisons() {
      this.combinaisons = [];
      for (const c1 of this.cerveaux) {
        for (const c2 of this.cerveaux) {
          if (c1 !== c2) {
            for (const niveau of this.niveaux) {
              this.combinaisons.push({
                cerveau1: c1,
                cerveau2: c2,
                energie: niveau.name,
                niveau: niveau.title,
                texte: '',
                image: ''
              });
            }
          }
        }
      }
    },
    async submitNiveau() {
      try {
        await axios.post(`/api/test/${this.testId}/niveaux`, {
          testId: this.testId,
          niveaux: this.niveaux
        });
        this.generateCombinaisons();
      } catch (error) {
        console.error('Erreur sauvegarde niveaux', error);
      }
    },
    async submitText() {
      try {
        await axios.post(`/api/test/${this.testId}/combinaisons`, {
          testId: this.testId,
          combinaisons: this.combinaisons
        });
        console.log('✅ Textes enregistrés');
      } catch (error) {
        console.error('Erreur sauvegarde textes', error);
      }
    },
    async onFileChange(event: Event, index: number) {
      const target = event.target as HTMLInputElement;
      if (!target.files?.length) return;

      const formData = new FormData();
      formData.append('file', target.files[0]);

      try {
        const res = await axios.post(`/api/test/${this.testId}/combinaison/${index}/upload_image`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        this.combinaisons[index].image = res.data.url;
      } catch (err) {
        console.error("Erreur upload image", err);
      }
    }
  },
  async mounted() {
    const niveauxRes = await axios.get(`/api/test/${this.testId}/niveaux`);
    this.niveaux = niveauxRes.data.length ? niveauxRes.data : this.niveaux;

    const combRes = await axios.get(`/api/test/${this.testId}/combinaisons`);
    this.combinaisons = combRes.data.length ? combRes.data : this.combinaisons;

    if (!(niveauxRes.data.length && combRes.data.length)) {
      this.generateCombinaisons();
    }
  }
});
